export default "__VITE_ASSET__Cjj8zgdO__"